export default {"src":"/_next/static/media/PPIBG.7c184f18.svg","height":3237,"width":1441,"blurWidth":0,"blurHeight":0};